/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react'

import styled from 'styled-components'
import moment from 'moment'
import { useToasts } from 'react-toast-notifications'

import { P } from '../../../../../style/Typography.style'

import EmptyWrapper from '../../../../EmptyWrapper'

import axiosInstance from '../../../../../services/config/AxiosIntance'

import { SlArrowDown, SlArrowUp } from 'react-icons/sl'

const QuestionLogs = ({ id, interview_id }) => {
  const [showHistory, setshowHistory] = useState(true)
  const [logs, setLogs] = useState([])

  const linkIcon = showHistory ? <SlArrowUp /> : <SlArrowDown />
  const linkText = showHistory ? 'Hide History' : 'Show History'

  const { addToast } = useToasts()

  const handleHistoryButtonClick = () => {
    setshowHistory(!showHistory)
  }

  const getQuestionLogs = async () => {
    try {
      return await axiosInstance.get(
        `/interviews/question-logs?question_id=${id}&interview_id=${interview_id}`
      )
    } catch (error) {
      addToast('Something went wrong.', {
        appearance: 'error',
        autoDismiss: true,
      })
    }
  }

  const parseAnswer = (answer) => {
    const parsed = JSON.parse(answer)?.answer.toString()
    const booleanMap = {
      true: 'Yes',
      false: 'No',
    }

    const answerStr = String(parsed)

    return Object.prototype.hasOwnProperty.call(booleanMap, answerStr)
      ? booleanMap[answerStr]
      : parsed
  }

  const createLogMessage = (name, answer) => `${name} answered ${answer}`

  const parseDate = (date) =>
    `${moment(date).format('MMMM Do, YYYY | h:mm A')} GMT ${moment(date).format(
      'ZZ'
    )}`

  useEffect(() => {
    if (showHistory) {
      getQuestionLogs().then((res) => {
        const response = res.data
        const result = response.map((e) => ({
          id: e.id,
          message: createLogMessage(e.name, parseAnswer(e.answer)),
          date: parseDate(e.created_at),
        }))
        setLogs(result)
      })
    }
  }, [showHistory])

  return (
    <Wrapper>
      <div className="links" onClick={handleHistoryButtonClick}>
        <P
          marginTop="0.5rem"
          marginBottom="0.5rem"
          marginRight="0.5rem"
          cursor="pointer"
          weight="500"
        >
          {linkText}
        </P>
        {linkIcon}
      </div>
      {showHistory && (
        <>
          <ul>
            {logs?.length > 0 ? (
              logs.map((log) => (
                <StyledLog key={log.id}>
                  <P size="0.75rem" marginBottom="0.35rem">
                    {log.message}
                  </P>
                  <P size="0.625rem" color="#676E92">
                    {log.date}
                  </P>
                </StyledLog>
              ))
            ) : (
              <EmptyWrapper message="No history for this question" />
            )}
          </ul>
        </>
      )}
    </Wrapper>
  )
}

const Wrapper = styled.div`
  .links {
    display: flex;
    align-items: center;
    cursor: pointer;
  }
`

const StyledLog = styled.li`
  width: 100%;
  padding: 0 1rem;
  padding-bottom: 0.5rem;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 3px;
    left: 0;
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
    border: 1px solid #c4d0e9;
    background: #fff;
  }

  &::before {
    content: '';
    position: absolute;
    top: 4px;
    left: 4px;
    height: calc(100% - 4px);
    width: 1px;
    background: #c4d0e9;
  }
`

export default QuestionLogs
